import React from "react";

interface TabletFrameProps {
  children: React.ReactNode;
  brandColor?: string;
}

const TabletFrame: React.FC<TabletFrameProps> = ({ children }) => {
  return (
    <div className="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-p-4">
      {/* Tablet Frame */}
      <div className="tw-relative tw-bg-black tw-rounded-[1.5rem] tw-p-3 tw-shadow-2xl tw-w-[min(90%,calc(70vh*4/3))] md:tw-w-[min(85%,calc(75vh*4/3))] lg:tw-w-[min(80%,calc(80vh*4/3))] xl:tw-w-[min(75%,calc(85vh*4/3))] tw-h-[min(88vh,calc(90%*3/4))] md:tw-h-[min(91vh,calc(85%*3/4))] lg:tw-h-[min(94vh,calc(80%*3/4))] xl:tw-h-[min(98vh,calc(75%*3/4))] tw-aspect-[4/3]">
        {/* Screen */}
        <div className="tw-bg-white tw-rounded-[1rem] tw-overflow-hidden tw-relative tw-w-full tw-h-full">
          {/* Status Bar */}
          <div className="tw-h-8 tw-bg-gray-900 tw-flex tw-items-center tw-justify-between tw-px-8 tw-text-white tw-text-sm tw-flex-shrink-0">
            <div className="tw-flex tw-items-center tw-space-x-4">
              <span className="tw-font-medium">10:24 AM</span>
              <span className="tw-text-xs tw-opacity-75">Tuesday, Dec 19</span>
            </div>
            <div className="tw-flex tw-items-center tw-space-x-3">
              {/* WiFi indicator */}
              <div className="tw-flex tw-space-x-1">
                <div className="tw-w-1 tw-h-2 tw-bg-white tw-rounded-full"></div>
                <div className="tw-w-1 tw-h-3 tw-bg-white tw-rounded-full"></div>
                <div className="tw-w-1 tw-h-4 tw-bg-white tw-rounded-full"></div>
                <div className="tw-w-1 tw-h-2 tw-bg-gray-500 tw-rounded-full"></div>
              </div>
              {/* Battery */}
              <div className="tw-w-8 tw-h-4 tw-border tw-border-white tw-rounded-sm">
                <div className="tw-w-6 tw-h-3 tw-bg-white tw-rounded-sm tw-m-0.5"></div>
              </div>
              <span className="tw-text-xs">87%</span>
            </div>
          </div>

          {/* App Content */}
          <div
            className="tw-flex-1 tw-w-full tw-overflow-hidden"
            style={{ height: "calc(100% - 2rem)" }}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TabletFrame;
